<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url("./common/style/common.css");
#app {
  font-family: Roboto, Helvetica, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue